import { useState, useCallback } from "react";
import { accountService } from "@miplatform/api";
import { HTTP_STATUSES } from "@miplatform/constants";
import { useComponentState } from "@miplatform/hooks";

export function useImportQuickBooksCustomersViewModel() {
  const stateManager = useComponentState();
  const [customers, setCustomers] = useState([]);

  const getCustomersForImport = useCallback(async () => {
    stateManager.run(async () => {
      const response = await accountService.quickBooks.getImports();

      if (response.status === HTTP_STATUSES.OK) {
        setCustomers(response.data);
      }
    });
  }, [stateManager]);

  return {
    isLoading: stateManager.isBusy(),
    customers,
    getCustomersForImport,
  };
}
